import { Web2PublishChiliEditor } from 'components/Web2Publish/components/ChiliEditor';

const ScreenChiliEditor = () => {
  return <Web2PublishChiliEditor />;
};

export default ScreenChiliEditor;
